module.exports = __webpack_public_path__ + "static/media/dsc_0389.1a3c86b3.jpg";